import type { Rebate } from '@urbanx/agx.agencies.client';
import type { ReactElement } from 'react';
import { LineItems } from './LineItems';
import { maximumRebates, rebateLimitMessage } from './lineItemSchemas';
import { rebateFields, type RebateField } from './rebateFields';

interface Props {
  value: Rebate[];
  disabled: boolean;
  emptyLabel?: string;
  errorText?: string;
  onChange(value: Rebate[]): void;
  renderField(index: number, field: RebateField): ReactElement;
}

export const RebateListEditor = ({
  value,
  disabled,
  emptyLabel,
  errorText,
  onChange,
  renderField,
}: Props) => (
  <LineItems
    noun="rebate"
    rowLabel="Rebate"
    count={value.length}
    maximumCount={maximumRebates}
    limitMessage={rebateLimitMessage}
    disabled={disabled}
    emptyLabel={emptyLabel}
    errorText={errorText}
    onAdd={() => onChange([...value, { supplier: '', service: '', estimatedAmount: '' }])}
    onRemove={(index) => onChange(value.filter((_, row) => row !== index))}
    renderFields={(index) => rebateFields.map((field) => renderField(index, field))}
  />
);
